<template>
    <div v-if="showEmailMessage && ( authUser && !authUser.email_verified_at )" class="text-white px-6 py-2 relative bg-green-500">
        <span class="inline-block align-middle mr-8">
            <b>Please confirm your email by clicking the link we sent to {{ authUser.email }} </b>
        </span>
        <button 
            @click="sendVerificationCode"
            class="bg-white text-green-700 font-semibold py-2 px-4 my-2 border border-green-500 hover:border-transparent rounded">
            Resend confirmation email
        </button>
        <button class="absolute bg-transparent text-2xl font-semibold leading-none right-0 top-0 mt-4 mr-6 outline-none focus:outline-none" @click="closeAlert(event)">
            <span>×</span>
        </button>
    </div>
</template>
<script>
export default {
    data() {
        return {
            showEmailMessage: true,
            authUser: this.$page.props.user,
        }
    },
    methods: {
        closeAlert(_event) {
            this.showEmailMessage = false;
        },
        sendVerificationCode() {
            axios.post('/resend-email-verified',{ email: this.authUser.email} )
                .then( (res) => {
                })
                .catch( (res) => {
                    console.log("catch res", res );
                })
        },
    },
}
</script>